import {neverland as $, html} from 'neverland';
import { verifyMFA } from '../lib/cognito.js';

const MFAVerifyPage = $(function({auth, setAuth}) {

  async function verifyCode() {
    const totpCode = document.getElementById('mfa-code').value;
    
    if (!totpCode || totpCode.length !== 6) {
      document.getElementById('error-message').textContent = 'Please enter a valid 6-digit code';
      document.getElementById('error-message').style.display = 'block';
      return;
    }

    try {
      document.getElementById('error-message').style.display = 'none';
      await verifyMFA(auth.cognitoUser, totpCode);
      
      // MFA verified successfully, complete login
      setAuth(prevAuth => ({
        ...prevAuth,
        publicPage: null,
        isLoggedIn: true,
        currentUser: auth.cognitoUser
      }));
    } catch (err) {
      document.getElementById('error-message').textContent = 'Invalid code. Please try again.';
      document.getElementById('error-message').style.display = 'block';
    }
  }

  function handleKeyPress(event) {
    if (event.keyCode === 13) {
      event.preventDefault();
      verifyCode();
    }
  }

  function goBack() {
    setAuth(prevAuth => ({
      ...prevAuth,
      publicPage: null,
      cognitoUser: null
    }));
  }

  return html`
    <div class="mfa-verify">
      <h2>Multi-Factor Authentication</h2>
      <p>Enter the 6-digit code from your authenticator app:</p>
      
      <div class="mfa-form">
        <input 
          id="mfa-code" 
          type="text" 
          maxlength="6" 
          placeholder="000000"
          onkeyup="${handleKeyPress}"
          autofocus
        />
        
        
        <button onclick="${verifyCode}" class="verify-button">Verify</button>
        <button onclick="${goBack}" class="back-button">Back to Login</button>
        
        <div id="error-message" class="error" style="display: none;"></div>
      </div>
    </div>
  `;
});

export default MFAVerifyPage;